import { getParam } from 'features/signup/utils/signupUtils';
import { useEffect } from 'react';
import { campaignAnalytics } from 'shared/constants/urlParams';
import { useAnalyticsConfiguration } from 'shared/hooks/analytics/useAnalyticsConfiguration';
// Hook to track campaign session data such as shareID and roktClickId obtained from URL parameters from our marketing site
export const useCampaignSessionTracking = (
  urlSearchParams: Record<string, string | string[]>,
) => {
  const { segmentClient } = useAnalyticsConfiguration();

  const shareID = getParam(urlSearchParams, campaignAnalytics.shareid);
  const clickID = getParam(urlSearchParams, campaignAnalytics.rtid);

  useEffect(() => {
    if (clickID) {
      segmentClient.setMarketingSessionData('roktClickId', clickID);
    }
    if (shareID) {
      segmentClient.setMarketingSessionData('shareid', shareID);
    }
  }, [clickID, segmentClient, shareID]);

  //return the IDs for potential further use, although primarily they are set/retrieved via session data
  return { shareID, clickID };
};
